import type { ReactNode } from 'react';
import {
  AiStar,
  BellIcon,
  CheckboxFilledIcon,
  DownloadIcon,
  EditChartIcon,
  FlyIcon,
  GridIcon,
  HomeProductIcon,
  LinkInlineIcon,
  ListMenuIcon,
  LocationIcon,
  LogiblocksIcon,
  MapSettingsIcon,
  PlusIcon,
  RocketIcon,
  SearchIcon,
  UserIcon,
  WarningIcon,
} from '@/assets/icons/icons';

// currentColor so icons follow the card's text color in both themes.
// Keyed by the icon name the backend sends.
const taskIcons: Record<string, () => ReactNode> = {
  person: () => <UserIcon size={20} color='currentColor' />,
  gear: () => <MapSettingsIcon size={24} color='currentColor' />,
  pkg: () => <HomeProductIcon width={24} height={24} color='currentColor' />,
  rocket: () => <RocketIcon width={24} height={24} color='currentColor' />,
  bell: () => <BellIcon width={24} height={24} color='currentColor' />,
  warn: () => <WarningIcon width={24} height={24} fill='currentColor' />,
  plus: () => <PlusIcon width={24} height={24} fill='currentColor' />,
  ext: () => <LinkInlineIcon width={24} height={24} color='currentColor' />,
  list: () => <ListMenuIcon width={20} height={12} fill='currentColor' />,
  dash: () => <EditChartIcon width={24} height={24} color='currentColor' />,
  pin: () => <LocationIcon width={24} height={24} color='currentColor' />,
  spark: () => <AiStar size={24} color='currentColor' />,
  plane: () => <FlyIcon size={22} color='currentColor' />,
  route: () => <LogiblocksIcon size={24} color='currentColor' />,
  search: () => <SearchIcon width={24} height={24} fill='currentColor' />,
  down: () => <DownloadIcon width={24} height={24} fill='currentColor' />,
};

const topicIcons: Record<string, () => ReactNode> = {
  'getting-started': () => <CheckboxFilledIcon fill='currentColor' />,
  shipments: () => <HomeProductIcon width={24} height={24} />,
  alerts: () => <WarningIcon fill='currentColor' width={24} height={24} />,
  dashboard: () => <GridIcon color='currentColor' width={24} height={24} />,
  ai: () => <AiStar color='currentColor' size={24} />,
  reports: () => <ListMenuIcon fill='currentColor' width={18} height={10} />,
  users: () => <UserIcon color='currentColor' size={16} />,
  settings: () => <MapSettingsIcon color='currentColor' size={24} />,
};

// Unknown task icons render nothing; unknown topics fall back to getting-started.
export const getHelpCenterIcon = (
  kind: 'task' | 'topic',
  name: string
): ReactNode => {
  if (kind === 'task') return taskIcons[name]?.() ?? null;
  return (topicIcons[name] ?? topicIcons['getting-started'])();
};
